const DANNY_PHOTO = "https://customer-assets.emergentagent.com/job_site-creator-2145/artifacts/omqzty4u_15336.png";
const LOGO_IMG = "https://customer-assets.emergentagent.com/job_site-creator-2145/artifacts/e4iuvkva_15045.png";

export default function About() {
  return (
    <section
      data-testid="about-section"
      className="relative py-24 md:py-32 lg:py-40 bg-[#0a0a0a]/[0.93]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: Danny portrait */}
          <div className="relative">
            <div className="rounded-lg overflow-hidden border border-[#c9a84c]/15 bg-black">
              <img
                src={DANNY_PHOTO}
                alt="Danny Davies - Founder of Chef Compliance UK"
                className="w-full h-[320px] sm:h-[420px] lg:h-[540px] object-cover object-top"
                data-testid="about-image"
              />
            </div>
            {/* Floating badge */}
            <div
              data-testid="about-floating-stat"
              className="absolute -bottom-4 right-4 lg:-bottom-5 lg:-right-5 p-4 lg:p-5 bg-[#0a0a0a] border border-[#c9a84c]/30 rounded-xl"
            >
              <p className="font-heading text-3xl font-semibold text-gold">20+</p>
              <p className="text-xs text-zinc-400 mt-1 uppercase tracking-wider">
                Years in Professional Kitchens
              </p>
            </div>
          </div>

          {/* Right: Bio */}
          <div>
            <div className="gold-line mb-6" />
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-gold">
              Meet the Founder
            </span>
            <h2
              data-testid="about-heading"
              className="font-heading text-3xl md:text-4xl font-medium text-white mt-4 leading-tight"
            >
              Danny Davies
              <br />
              <span className="text-zinc-500">Founder & Director</span>
            </h2>
            <p className="mt-6 text-base text-zinc-400 leading-relaxed">
              I'm Danny, founder of Chef Compliance UK, with over 20 years of
              experience operating at the sharp end of professional kitchens. My
              background isn't theory — it's built on real service, real pressure,
              and direct experience managing compliance, standards, and EHO
              expectations in live environments where there's no room for error.
            </p>
            <p className="mt-4 text-base text-zinc-400 leading-relaxed">
              Chef Compliance UK was established to offer something fundamentally
              different: a higher standard of compliance. Not generic templates or
              overcomplicated systems, but structured, precise, and operationally
              sound solutions designed for businesses that take their standards
              seriously.
            </p>
            <p className="mt-4 text-sm text-zinc-500 leading-relaxed italic">
              "I work with operators who want clarity, control, and confidence in
              their compliance — those who understand that strong systems don't
              just pass inspections, they protect reputation and support long-term
              growth."
            </p>

            <div className="mt-8 flex items-center gap-6">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-gold" />
                <span className="text-sm text-zinc-300">HACCP Specialist</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-gold" />
                <span className="text-sm text-zinc-300">EHO Ready Systems</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
